import type {ReactElement} from 'react';
import {useRef} from 'react';
import {Text, TextSize} from '@Components/text';
import {useIsElementContentClamped} from '@Components/social-media/components/social-post-content-multiposting/social-post-content-multiposting.hooks';
import type {PreviewClampedCaptionProps} from './preview-clamped-caption.types';
import styles from './preview-clamped-caption.module.scss';

export function PreviewClampedCaption({captionText, children, className = '', textClassName = ''}: PreviewClampedCaptionProps): ReactElement {
  const captionTextRef = useRef<HTMLDivElement>(null);
  const isCaptionClamped = useIsElementContentClamped(captionTextRef, captionText);

  const getCaptionMoreSuffix = (): ReactElement | null => {
    if (!isCaptionClamped) {
      return null;
    }

    return <Text className={styles.clampedCaptionMore} size={TextSize.XS} val={`… ${window.i18next.t('pmwjs_more')}`} />;
  };

  return (
    <div className={`${styles.clampedCaption} ${className}`}>
      <div className={`${styles.clampedCaptionText} ${textClassName}`} ref={captionTextRef}>
        {children}
      </div>
      {getCaptionMoreSuffix()}
    </div>
  );
}
